import { useSelector } from "react-redux";
import _ from "lodash";
import { RootState } from "@Reducers/index";
import { ADDON_CODE_TO_LAYOUT_FLAG } from "@Helpers/constants";

export type LayoutFlagPath = (typeof ADDON_CODE_TO_LAYOUT_FLAG)[keyof typeof ADDON_CODE_TO_LAYOUT_FLAG];

const useLayoutModuleAccess = (flagPath: LayoutFlagPath | undefined) => {
  const layout = useSelector((state: RootState) => state.layout);
  return {
    isReady: !!layout && Object.keys(layout).length > 0,
    allowed: !!flagPath && !!_.get(layout, flagPath),
  };
};

export default useLayoutModuleAccess;
